/* eslint-disable max-len */
import React from 'react';
import { Switch, Route, withRouter, NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import DashboardContainer from './container/DashboardContainer';
import CitizenContainer from './container/CitizenContainer';

function MainCitizenContainer({ match }) {
  return (
    <div className="module-inner">
      <div className="module-inner-title">Citizens</div>
      <div className="generic-module-nav mb-3">
        {/* <NavLink
          exact
          className="nav-link"
          activeClassName="active"
          to="/citizens"
        >
          Dashboard
        </NavLink> */}

        <NavLink
          exact={false}
          className="nav-link"
          activeClassName="active"
          to="/citizens/profiles"
        >
          Profiles
        </NavLink>
      </div>
      <Switch>
        <Route exact path={`${match.path}`} component={DashboardContainer} />
        <Route path={`${match.path}/profiles`} component={CitizenContainer} />
      </Switch>
    </div>
  );
}

MainCitizenContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
};

export default withRouter(MainCitizenContainer);
